import { splitBy, toMapFn } from "~/common/utils/reducers";
import { type PackagingInformationEntry } from "~/domains/product/types/ProductData";
import { INVALID_PACKAGE_CODE } from "~/utils/constants";
import { SalesStatus } from "~/features/productDetails/components/PhaseInOut/SalesStatus";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

export type PackagingWithStatus = PackagingInformationEntry & {
  salesStatus: string;
};

export function hasSuccessor(product: ProductDescriptor) {
  return product.base.successorProduct;
}

export function getPackagesBySalesType(product: ProductDescriptor) {
  const [discontinuedPackages, ongoingPackages] = splitBy(
    getPackages(product),
    (p) => p.salesStatus === SalesStatus.Discontinued,
  );

  return {
    discontinuedPackages,
    ongoingPackages,
  };
}

export function isDiscontinued(packaging: PackagingWithStatus) {
  return packaging.salesStatus === SalesStatus.Discontinued;
}

export function getPackages(product: ProductDescriptor): PackagingWithStatus[] {
  const packages = product.availability?.packagingInformation ?? [];
  const salesStatusMap = toMapFn(
    Object.entries(product.base.fifteenDigit ?? {}),
    ([code]) => code,
    ([_, o]) => o.salesStatus,
  );
  return packages
    .map((packaging) => ({
      ...packaging,
      salesStatus: salesStatusMap[packaging.packCode],
    }))
    .filter((p) => {
      return !(p.packCode === INVALID_PACKAGE_CODE && p.salesStatus === SalesStatus.Discontinued);
    });
}
